var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaymobArrow = function SvgPaymobArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 184,
    viewBox: "0 0 247 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_5449_22149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.031199 66.6969L66.4076 0L141.272 75.2261L109.254 107.399C90.2807 126.464 59.511 126.464 40.5373 107.399L0 66.6656L0.031199 66.6969Z",
    fill: "url(#paint0_linear_5449_22149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.201 81.3096L213.578 148.007L88.1897 274L57.3888 243.05C37.7598 223.327 37.7598 191.311 57.3888 171.587L147.201 81.3409V81.3096Z",
    fill: "url(#paint1_linear_5449_22149)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5449_22149",
    x1: 70.6361,
    y1: 0,
    x2: 70.6361,
    y2: 121.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5449_22149",
    x1: 128.122,
    y1: 81.3096,
    x2: 128.122,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5449_22149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 274,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaymobArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PaymobArrow.44014906a8ca9cc169226123ed2f3247.svg";